<script setup>
import Layout from "./Authenticated.vue";
import { Link } from "@inertiajs/inertia-vue3";
import {onMounted} from "vue";
import {useToast} from "primevue/usetoast";

const props = defineProps([
    'customer',
    'menuItems',
    'flash',
]);

const toast = useToast()

onMounted(() => {
    if (props.flash?.severity) {
        toast.add({
            severity: props.flash.severity,
            summary: props.flash.value,
            life: 5000,
        });
    }
})

</script>
<template>
    <Layout>
        <div class="lato max-w-7xl mx-auto p-4 my-10">
            <div class="text-xl font-normal mb-4">Kunden</div>
            <div class="text-xl font-bold mb-7">{{ customer.first_name }} {{ customer.last_name }}</div>

            <div class="flex gap-[3em] mx-auto pb-14">
                <nav class="max-w-[250px]">
                    <li v-for="(data, i) in menuItems" class="text-black list-none my-4" :class="{
                        'mt-0': i === 0,
                    }">
                        <Link v-if="! data.active" :href="data.url">
                            {{ data.label }}
                        </Link>
                        <span v-else class="font-bold">{{ data.label }}</span>

                        <nav v-if="data.sub_menu" class="ml-5">
                            <li v-for="submenuData in data.sub_menu" class="my-2">
                                <Link v-if="! submenuData.active" :href="submenuData.url">
                                    {{ submenuData.label }}
                                </Link>
                                <span v-else class="font-bold">{{ submenuData.label }}</span>
                            </li>
                        </nav>
                    </li>
                </nav>

                <div class="flex-1">
                    <div class="bg-white rounded">
                        <slot />
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
